/** @prettier */
import { API_ROOT, makeRequest } from "../services/qbankApi";
import { TestMode } from "./models";
import { TestData } from "./Run/testRunnerApi";
export type QuestionPerformanceResult = {
    number: number; // Added locally, not part of API data
    result: "CORRECT" | "INCORRECT" | "UNANSWERED";
    flagged: boolean;
    category: string;
    subcategory: string;
    topic: string;
    // questionId: number; // on payload, but unused
};

export type TestPerformanceData = {
    id: string;
    testName: string;
    createdOn: string; // Date?
    submittedOn: string; // Date?
    testMode: TestMode;
    totalQuestionCount: number;
    unansweredQuestionCount: number;
    correctQuestionCount: number;
    incorrectQuestionCount: number;
    totalFlaggedQuestionCount: number;
    // flaggedUnansweredQuestionCount: 0;
    // flaggedCorrectQuestionCount: 0;
    // flaggedIncorrectQuestionCount: 0;
    testQuestionsPerformanceWS: QuestionPerformanceResult[];
    // performanceAreas: // Breakdown by subject, category, subcategory
};

export const getTestPerformanceData = async (id: string) => {
    const url = `${API_ROOT}performance/tests/${id}`;

    const res = (await (
        await makeRequest("GET", url)
    ).json()) as TestPerformanceData;
    // Attach the id to the data for convenience
    res.id = id;
    // Add question numbers to api payload
    res.testQuestionsPerformanceWS.forEach((question, i) => {
        question.number = i + 1;
    });
    return res;
};

export const retakeTest = async (id: string) => {
    const url = `${API_ROOT}tests/${id}/retake`;
    return (await (await makeRequest("GET", url)).json()) as TestData;
};
